<template>
<div>
	<div fillHeight="lastHeight" class='mMeduce' scroll ref="detailContent">
		<div class="mb1x vaT_E">
			<!-- 分布start -->
			<div class="panel bgPanel mt1x cb mr1x ml1x">
				<div class="title fs14x">
					<span>{{$t("word1262",["分布"])}}</span>
					<div class="fR fs1ax cField tra-fast_E vaM_E hover-cMain_E">
						<button id="prev" class="w2x fa fa-angle-left fs14x" type="button" @click="dateChange('perv')" onclick="statistic('A37','A3704')"></button>
						<vue-datepicker-local v-model="time" :format="'YYYY/MM/DD'" ref="date" :local="local" class="datepicker " @input="_showChart()" onclick="statistic('A37','A3705')"></vue-datepicker-local>
						<button id="next" class="w2x fa fa-angle-right fs14x" type="button" @click="dateChange('next')" onclick="statistic('A37','A3706')"></button>
					</div>
				</div>
				<div class="w100pct cb pr1x pl1x">
					<loading v-if="isChart" class="chartLoading"></loading>
					<div class="pl1x pr1x">
						<span class="cMainContent">{{detailInfo.showName}}</span>
					</div>
					<div class="h14x mb2x posR">
						<Loading ref="loadingChartAlarm"></Loading>
						<ChartTime :data="ChartTimeData" :lastValidTime="lastValidTime" :option="defChartTimeOption" :chartClass="'h14x'"></ChartTime>
					</div>
					<div v-show="detailData.length" class="taR posR clearfix dateSys titleBar title-bg taR">
						<button @click="paramChooiceShow" :title="getLanguageStr('word566','参数选择')" class="cSub bdSub pl1x pr1x sizeS curP" onclick="statistic('A37','A3707')">{{getLanguageStr('word566','参数选择')}}</button>
						<DeviceDetailParam ref="DeviceDetailParam" :sty="'right:0'" :productId="detailInfo.productId" @selectArray="updateShowParamArray"></DeviceDetailParam>
					</div>
					<div class="h28x mb1x posR">
						<Loading ref="loadingChartLine"></Loading>
						<ChartLine :data="ChartData" :option="defChartLineOption" :chartClass="'h28x'"></ChartLine>
					</div>
				</div>
			</div>
			<!-- 分布end -->
		</div>
		<div class="mb1x vaT_E">
			<!-- 原因及解决方案start -->
			<div class="panel bgPanel mt1x cb mr1x ml1x">
				<div class="title title-bg">
					<span>{{$t("plant70",["解决方案"])}}</span>
				</div>
				<div v-show="detailInfo.customAlertConfigDisplayReason && detailInfo.customAlertConfigDisplayReason.length" v-for="(item,index) in detailInfo.customAlertConfigDisplayReason" :key="index">
					<div class="ml1x_E mr1x_E mb1x_E w100pct cb ofA">
						<div class="bgLight boxR-light pl1x pr1x pt2x pb2x">
							<span class="cMainContent lh15">{{index + 1}}.{{item.solution}}</span>
						</div>
					</div>
				</div>
			</div>
			<!-- 原因及解决方案end -->
		</div>
	</div>
</div>
</template>
<script>
import { mapGetters, mapMutations, mapActions} from 'vuex'
import * as maintainApi from '@/api/maintain/alarm/list'
import * as deviceApi from '@/api/device/alarm/list'
import {deviceStatsDay} from '@/api/device/list'
import * as lib from '@/util/lib.js'
import {getLocal} from '@/util'
import Loading from '@/components/common/ui/Loading'
import ChartTime from '@/components/common/chart/ChartTime.vue'
import ChartLine from '@/components/common/chart/ChartLine.vue'
import DeviceDetailParam from '@/view/device/device/part/DeviceDetailParam'	// 设备图表参数

import {getLanguageStr} from '@/util/language.js'

export default {
	components: {Loading, ChartTime, ChartLine, DeviceDetailParam},
	props: {
		timezone: {
			type: String,
			default: stage.time.timeZoneCode
		}
	},
	data () {
		return {
			detailInfo: {},
			ChartTimeData: [],
			lastValidTime: null,
			defChartTimeOption: {},
			defChartLineOption: {},
			local: {},
			isChart: true,
			time: null,
			ChartData: [], // 图标数据,
			defaultParamArray: ['DV1', 'AV1'],
			showParamArray: ['DV1', 'AV1'], // 选择的参数模板,默认显示DV1、AV1
			detailData: [],
			chartList: [],
			sourceType: '',
			offset: 0
		}
	},
	computed: {
		...mapGetters({
		})
	},
	watch: {
	},
	created () {
		this._getLocal()
	},
	mounted () {
	},
	methods: {
		getLanguageStr,
		floatFix: lib.floatFix,
		convertData: lib.convertData,
		getTypeText: lib.getTypeText,
		...mapMutations({
		}),
		show (data, sourceType) {
			this.offset = mz.tz(this.timezone)._offset * 60 * 1000
			this.sourceType = sourceType
			this.detailInfo = data
			let year = lib.timeFormat(this.detailInfo.alertTime, 'utc', '%Y', {offset: this.timezone})
			let month = lib.timeFormat(this.detailInfo.alertTime, 'utc', '%m', {offset: this.timezone})
			let day = lib.timeFormat(this.detailInfo.alertTime, 'utc', '%d', {offset: this.timezone})
			this.time = new Date(year, month - 1, day)
			var _this = this
			this.$refs.DeviceDetailParam.getDefaultParamList(this.detailInfo.productId, this.detailInfo.deviceType).then(function (res) {
				_this.defaultParamArray = res
			})
			// this.time=new Date(this.detailInfo.alertTime*1000);
			this._showChart()
		},
		_getLocal () {
			this.local = getLocal()
		},
		// 日历
		dateChange (str) {
			let val = this.$refs.date.text
			let date = new Date(val.split('~').pop())
			let step = str === 'next' ? 1 : -1
			date.setDate(date.getDate() + step)
			this.$refs.date.selectOk(date)
		},
		_showChart () {
			this.isChart = true
			this.chartList = [],
			this._chartTime()
			this._chartLine()
		},
		// 获取报警时序
		_chartTime () {
			this.$refs.loadingChartAlarm.show()
			this.ChartTimeData = []
			let year = lib.timeFormat(this.time, 'system', '%Y')
			let month = lib.timeFormat(this.time, 'system', '%m')
			let day = lib.timeFormat(this.time, 'system', '%d')
			if (this.sourceType == 'plant') {
				maintainApi.timelineDataGet({
					deviceId: this.detailInfo.deviceId,
					// alertDay: year + (10 > month ? '0' : '') + month + (10 > day ? '0' : '') + day,
					alertDay: year + month + day,
					ruleId: this.detailInfo.ruleId
				}).then(res => {
					this.$refs.loadingChartAlarm.hide()
					this.isChart = false
					if (res.length) {
						this.formatTimeDate(res, year, month, day)
					}
				}, error => {
					this.$refs.loadingChartAlarm.hide()
					this.isChart = false
					!_.isEmpty(error) && this.$notify(error)
				})
			} else if (this.sourceType == 'device') {
				deviceApi.timelineDataGet({
					deviceId: this.detailInfo.deviceId,
					alertDay: year + month + day,
					// alertDay: year + (10 > month ? '0' : '') + month + (10 > day ? '0' : '') + day,
					ruleId: this.detailInfo.ruleId
				}).then(res => {
					this.$refs.loadingChartAlarm.hide()
					this.isChart = false
					if (res.length) {
						this.formatTimeDate(res, year, month, day)
					}
				}, error => {
					this.$refs.loadingChartAlarm.hide()
					this.isChart = false
					!_.isEmpty(error) && this.$notify(error)
				})
			}
		},
		formatTimeDate (data, year, month, day) {
			window.fomateTimeLine = {}
			let minVal = 1 // 图表单列最小值
			let maxVal = 4 // 图表单列最大值
			let duration = 4.9	// 某一条记录表示报警持续5分钟
			let firstTime = new Date(year, month - 1, day, 0, 0, 0, 0).getTime()+ mz.tz(this.timezone)._offset * 60 * 1000
			let lastTime = new Date(firstTime + 24 * 3600 * 1000).getTime()
			let filterData = []
			// console.log(lastTime)
			// 过滤重复及非当天的返回数据
			for (let i = 0; i < data.length; i++) {
				
				let isExist = false
				for (let j = 0; j < filterData.length; j++) {
					if (data[i] == filterData[j]) {
						isExist = true
						break
					}
				}
				if (!isExist) {
					filterData.push(data[i])
					// console.log(data[i] * 1000<lastTime,data[i] * 1000,lastTime,firstTime)
					// if (data[i] * 1000 < lastTime) {
					// 	// console.log(data[i] * 1000)
					// 	filterData.push(data[i])
					// }
				}
			}
			// 获取第一个时间
			let spDate = new Date(filterData[0] * 1000)
			 let lastd = Date.UTC(spDate.getUTCFullYear(), spDate.getUTCMonth(), spDate.getUTCDate() + 2, 0, 0, 0, 0)
	
			// 添补第一秒的数据
			// this.ChartTimeData.push([firstTime, null, null])	// 绘制开始时间点
			// 处理绘制数据，一块面积需要设置开始绘制时间点，绘制间距，结束绘制时间点
			for (let i = 0; i < filterData.length; i++) {
				let formatTime = filterData[i] * 1000 + mz.tz(this.timezone)._offset * 60 * 1000
				let fTs = new Date(filterData[i] * 1000)
				let nex = Date.UTC(fTs.getUTCFullYear(), fTs.getUTCMonth(), fTs.getUTCDate())
				// let formatTime = new Date(lib.timeFormat(targetTime, 'utc', '%Y', {offset: this.timezone}), lib.timeFormat(targetTime, 'utc', '%m', {offset: this.timezone}) - 1, lib.timeFormat(targetTime, 'utc', '%d', {offset: this.timezone}), lib.timeFormat(targetTime, 'utc', '%H', {offset: this.timezone}), lib.timeFormat(targetTime, 'utc', '%M', {offset: this.timezone}), lib.timeFormat(targetTime, 'utc', '%S', {offset: this.timezone}), 0).getTime()
				//  let formatTime = new Date(lib.timeFormat(targetTime, 'utc', '%Y'), lib.timeFormat(targetTime, 'utc', '%m') - 1, lib.timeFormat(targetTime, 'utc', '%d'), lib.timeFormat(targetTime, 'utc', '%H'), lib.timeFormat(targetTime, 'utc', '%M'), lib.timeFormat(targetTime, 'utc', '%S'), 0).getTime()
				if (!i) {
					if (formatTime == firstTime) {	// 如果第一条报警信息在00:00
						this.ChartTimeData[0][1] = minVal + 0.5
						this.ChartTimeData[0][2] = maxVal - 1.5
					} else {
						this.ChartTimeData.push([formatTime, minVal + 0.5, maxVal - 1.5])
					}
					this.ChartTimeData.push([formatTime + duration * 60000, minVal + 0.5, maxVal - 1.5])	// 绘制间距
					window.fomateTimeLine[formatTime + duration * 60000] = formatTime
					this.ChartTimeData.push([formatTime + duration * 60000 + 1000, null, null])	// 绘制结束时间点
				} else {
					if (formatTime > this.ChartTimeData[this.ChartTimeData.length - 2][0]) {	// 如果下一个报警时间点在5分钟之后
						this.ChartTimeData.push([formatTime, minVal + 0.5, maxVal - 1.5])	// 绘制开始时间点
					} else {	// 如果下一个报警时间点在5分钟之内
						this.ChartTimeData.pop()	// 删除上一个报警的结束时间
						this.ChartTimeData.pop()	// 删除上一个报警的间距
					}
					let nextTime = new Date(formatTime + duration * 60000).getTime()
				
					if (nex >= lastd || nextTime >= lastd) {
						this.ChartTimeData.push([lastTime-1000, minVal + 0.5, maxVal - 1.5])	// 绘制间距
					} else {
						this.ChartTimeData.push([nextTime, minVal + 0.5, maxVal - 1.5])	// 绘制间距
						window.fomateTimeLine[nextTime] = formatTime
						this.ChartTimeData.push([nextTime + 1000, null, null])	// 绘制结束时间点
					}
				}
				if (i == filterData.length - 1) {
					this.lastValidTime = formatTime
				}
			}

			// 添补最后一秒的数据
			if (!filterData.length) {
				this.ChartTimeData.push([lastTime-1000, null, null])
			} else {
				if (lastTime == this.ChartTimeData[this.ChartTimeData.length - 1][0]) {
					this.ChartTimeData[this.ChartTimeData.length - 1][1] = minVal + 0.5
					this.ChartTimeData[this.ChartTimeData.length - 1][2] = maxVal - 1.5
				} else {
					this.ChartTimeData.push([lastTime-1000, null, null])
				}
			}
			// this.ChartTimeData = Object.freeze(this.ChartTimeData)
			this.ChartTimeData.sort(this.sortMethod(0))
			// this.ChartTimeData = this.ChartTimeData
			this.defChartTimeOption = (function (timezone) {
				let obj = {
					yAxis: {
						min: minVal,
						max: maxVal
					},
					timezone
				}
				return obj
			}(this.timezone))
		},
		sortMethod (ChartTimeData) {
			return function (a, b) {
				var list1 = a[ChartTimeData]
				var list2 = b[ChartTimeData]
				return list1 - list2
			}
		},
		paramChooiceShow () {
			this.$refs.DeviceDetailParam.show(this.showParamArray, this.defaultParamArray)
		},
		updateShowParamArray (selectArray) {
			this.showParamArray = selectArray
			this.paramChatShow()
		},
		paramChatShow () {
			this.ChartData = []
			if (this.detailData.length > 0) {
				this.chartList = []
        let yt = []
        this.defaultParamArray = []
				this.detailData.map((item, i) => {
					if (this.showParamArray.includes(item.storageName)) {
            this.defaultParamArray.push(item.storageName)
						this.chartList[i] = {...item}
						this.chartList[i].data = []
						item.detailList.map(dl => {
							this.chartList[i].data.push([Number(dl.collectionTime) * 1000, Number(dl.value)])// 重组data
						})
						this.chartList[i].data = lib.sortData(this.chartList[i].data, {byKey: 0})
						this.ChartData.push(this.chartList[i]) // 重组chartData
            // console.log(yt)
						if (!yt.includes(item.unit)) yt.push(item.unit)// 添加y轴
					};
				})
				// console.log(yt)
				this.defChartLineOption = (function () { // 默认月图表参数
					let obj = { // d
						yTitle: yt
					}
					return obj
				}())
			}
		},
		_chartLine () {
			this.$refs.loadingChartLine.show()
			let chooseDay = {
				'day': lib.timeFormat(this.time, 'system', '%Y/%m/%d'),
				'lan': stage.languageId
			}
			deviceStatsDay(this.detailInfo.deviceId, chooseDay).then(res => {
				this.$refs.loadingChartLine.hide()
				this.isChart = false

				this.showParamArray = this.defaultParamArray
				if (res) {
					this.detailData = res.map(item => {
						if (this.defaultParamArray.includes(item.storageName)) item.selected = true; else item.selected = false
						if (item.detailList.length) {
							for (let index in item.detailList) {
								item.detailList[index].collectionTime = item.detailList[index].collectionTime + parseInt(this.offset / 1000)
							}
						}
						return item
					})
				} else {
					this.detailData = []
				}
				this.paramChatShow()
			}, error => {
				this.$refs.loadingChartLine.hide()
				this.isChart = false
				!_.isEmpty(error) && this.$notify(error)
			})
		}
	}
}
</script>
<style lang="scss" scoped>
.panel .title{ margin-bottom: 0 }
.datepicker{width:125px !important;height:2.2em;line-height:2.2em}
.datepicker-range{min-width: auto;}
.textCut_E >.s-title{color:$fontContentColor;max-width: 14em; display: inline-block; overflow: hidden; white-space: nowrap; text-overflow: ellipsis;padding-left:2px}
.chartLoading{
	min-height:3em;
	/deep/ .mt2x{
		margin-top:0
	}
}
.ofA{
	overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/view/maintain/alarm/part/Detail.vue